import React from 'react';
import { LuckyFlushPage } from './pages/LuckyFlushPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <LuckyFlushPage data-id="element-1" />
    </>;
}